import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Optional,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { SearchContactTypeModel } from '../../../core/models/contact-type.model'
import { MatButtonModule } from '@angular/material/button'
import {
  MatFormField,
  MatFormFieldModule,
  MatLabel,
} from '@angular/material/form-field'
import { MatInput, MatInputModule } from '@angular/material/input'
import { MatSelectModule } from '@angular/material/select'

import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'

import { MatIconModule } from '@angular/material/icon'
import {
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import {
  MatDatepicker,
  MatDatepickerModule,
} from '@angular/material/datepicker'
import { MatNativeDateModule, MatOption } from '@angular/material/core'
import { CommonModule } from '@angular/common'
import { MatTableModule } from '@angular/material/table'
import { MatPaginator } from '@angular/material/paginator'
import { DriverService } from '../../../core/services/driver/driver/driver.service'
import { ScheduleDriverService } from '../../../core/services/schedule/schedule-driver/schedule-driver.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { LegalEntityClientService } from '../../../core/services/customer/legal-entity-client/legal-entity-client.service'
import {
  MatAutocompleteModule,
} from '@angular/material/autocomplete'
import { LocationService } from '../../../core/services/location/location/location.service'
import { map, Observable, startWith } from 'rxjs'
import { removeAccents } from '../../../shared/utils/utils'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { ScheduleFleetService } from '../../../core/services/schedule/schedule-fleet/schedule-fleet.service'
import { MatTooltip } from '@angular/material/tooltip'
import { VehicleService } from '../../../core/services/vehicle/vehicle/vehicle.service'
import { SubClientService } from '../../../core/services/customer/sub-client/sub-client.service'
import { ModalLegalEntityClientComponent } from '../../../features/customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'
import { ModalLegalEntitySubClientComponent } from '../../../features/customer/modal_subclient/modal-legal-entity-subclient/modal-legal-entity-subclient.component'

@Component({
  selector: 'app-schedule-search',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormField,
    MatInput,
    MatLabel,
    MatIconModule,
    MatTableModule,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatDatepicker,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginator,
    MatSelectModule,
    MatOption,
    MatProgressSpinner,
    MatTooltip,
    MatAutocompleteModule,
    MatButtonModule,
  ],
  templateUrl: './schedule-search.component.html',
  styleUrl: './schedule-search.component.scss',
  standalone: true,
})
export class ScheduleSearchComponent implements OnInit {
  constructor(
    private driverService: DriverService,
    private formBuilder: FormBuilder,
    private scheduleDriverService: ScheduleDriverService,
    private legalEntityClientService: LegalEntityClientService,
    private snackbar: SnackbarCustomService,
    private locationService: LocationService,
    private serviceTypeService: ServiceTypeService,
    private vehicleTypeService: VehicleTypeService,
    private vehicleService: VehicleService,
    private driverTypeService: DriverTypeService,
    private scheduleFleetService: ScheduleFleetService,
    private subClientService: SubClientService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
  ) {}

  subClientsList: any[] = []
  origemControl = new FormControl()
  destinoControl = new FormControl()
  filteredDrivers!: Observable<any[]>
  filteredOrigins!: Observable<any[]>
  filteredDestinations!: Observable<any[]>
  filteredVehicles!: Observable<any[]>

  form!: FormGroup
  clientSelected: any = {}
  subClientSelected: any = {}
  itemsList: any[] = []
  loading = false
  listTypeDriver: any[] = []
  listDrivers: any[] = []
  listVehicles: any[] = []
  listTypeService: any[] = []
  listClient: any[] = []
  listLocation: any[] = []
  listTypeVehicle: any[] = []
  listStatus: any[] = [
    { descricao: 'Agendar', value: 4 },
    { descricao: 'Agendado', value: 5 },
    { descricao: 'Todos', value: 0 },
  ]

  isExpanded: any = false

  @Output() response = new EventEmitter<any>()
  @Output() loadingList = new EventEmitter<any>()
  @ViewChild('panel') panel!: MatExpansionPanel

  editIndex: number | null = null
  editAgendaItem: any = null
  page = 1
  rows = 10
  numberRows = 0
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  displayedColumns: string[] = ['date', 'startDate', 'endDate', 'action']
  columns: any[] = [
    { keyColumn: 'date', key: 'date', description: 'Data' },
    { keyColumn: 'startDate', key: 'startDate', description: 'Data Inicial' },
    { keyColumn: 'endDate', key: 'endDate', description: 'Data Final' },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]

  ngOnInit(): void {
    this.createForm()
    this.getListTypeDriver()
    this.getListClient()
    this.getListLocations()
    this.initOriginFilter()
    this.getListTypeService()
    this.getListTypeVehicle()
    this.listAllDrivers()
    this.listAllVehicle()
    this.listSubClients()
  }

  private _filter(value: string): any[] {
    const filterValue = value.toLowerCase()

    return this.listLocation.filter((opt) =>
      opt.descricao.toLowerCase().includes(filterValue),
    )
  }

  listAllDrivers() {
    this.driverService.listDriver().subscribe({
      next: (res) => {
        this.listDrivers = res.data
      },
      error: (err) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      },
    })
  }

  listAllVehicle() {
    this.vehicleService.listVehicles().subscribe({
      next: (res: any) => {
        this.listVehicles = res.data
      },
      error: (err: any) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      },
    })
  }

  addClient() {
    const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.clientSelected.id) {
            this.clientSelected = response.selection
            this.form.get('cliente')!.setValue(this.clientSelected.nomeFantasia)
            this.clearItem(['subCliente'])
            this.form.get('subCliente')!.enable()
          }
        } else {
          this.clientSelected = {}
          this.subClientSelected = {}
          this.form.get('subCliente')!.setValue('')
          this.form.get('cliente')!.setValue('')
          this.clearItem(['cliente', 'subCliente'])
          this.form.get('subCliente')!.disable()
        }
      }
    })
  }

  addSubClient() {
    const dialogRef = this.dialog.open(ModalLegalEntitySubClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        idClient: this.clientSelected.id,
        clientInfo: this.clientSelected,
        item: this.subClientSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response) => {
      if (response) {
        if (response.remove == false) {
          if (response.selection.id != this.subClientSelected.id) {
            this.subClientSelected = response.selection
            this.form
              .get('subCliente')!
              .setValue(this.subClientSelected.nomeFantasia)
          }
        } else {
          this.clearItem(['subCliente'])
        }
      }
    })
  }

  clearItem(items: string[]) {
    if (items.includes('client')) {
      this.clientSelected = {}
      this.form.get('client')!.setValue('')
    }
    if (items.includes('subClient')) {
      this.subClientSelected = {}
      this.form.get('subClient')!.setValue('')
    }
  }

  initOriginFilter(): void {
    this.filteredOrigins = this.form.get('origem')!.valueChanges.pipe(
      startWith(''),
      map((v) => {
        // Se for objeto, retorna a descrição
        if (v && typeof v === 'object' && v.descricao) {
          return v.descricao
        }
        if (v && typeof v === 'object' && v.estado) {
          return v.estado
        }
        // Se for string, retorna a string
        if (typeof v === 'string') return v
        return ''
      }),
      map((text) => (text ? removeAccents(text.toLowerCase()) : '')),
      map((searchText) => {
        return this.listLocation.filter((loc) => {
          const locDescription = loc?.descricao || ''
          const locState = loc?.estado || ''
          return (
            removeAccents(locDescription.toLowerCase()).includes(searchText) ||
            removeAccents(locState.toLowerCase()).includes(searchText)
          )
        })
      }),
    )

    this.filteredDestinations = this.form.get('destino')!.valueChanges.pipe(
      startWith(''),
      map((v) => {
        if (v && typeof v === 'object' && v.descricao) {
          return v.descricao
        }
        if (v && typeof v === 'object' && v.estado) {
          return v.estado
        }
        if (typeof v === 'string') return v
        return ''
      }),
      map((text) => (text ? removeAccents(text.toLowerCase()) : '')),
      map((searchText) => {
        return this.listLocation.filter((loc) => {
          const locDescription = loc?.descricao || ''
          const locState = loc?.estado || ''
          return (
            removeAccents(locDescription.toLowerCase()).includes(searchText) ||
            removeAccents(locState.toLowerCase()).includes(searchText)
          )
        })
      }),
    )

    this.filteredDrivers = this.form.get('driver')!.valueChanges.pipe(
      startWith(''),
      map((v) => {
        if (v && typeof v === 'object' && v.nome) {
          return v.nome
        }
        if (v && typeof v === 'object' && v.cpf) {
          return v.cpf
        }
        if (typeof v === 'string') return v
        return ''
      }),
      map((text) => (text ? removeAccents(text.toLowerCase()) : '')),
      map((searchText) => {
        return this.listDrivers.filter((loc) => {
          const driverName = loc?.nome || ''
          const driverCpf = loc?.cpf || ''
          return (
            removeAccents(driverName.toLowerCase()).includes(searchText) ||
            removeAccents(driverCpf.toLowerCase()).includes(searchText)
          )
        })
      }),
    )
    this.filteredVehicles = this.form.get('vehicle')!.valueChanges.pipe(
      startWith(''),
      map((v) => {
        if (v && typeof v === 'object' && v.placa) {
          return v.placa
        }
        if (typeof v === 'string') return v
        return ''
      }),
      map((text) => (text ? removeAccents(text.toLowerCase()) : '')),
      map((searchText) => {
        return this.listVehicles.filter((loc) => {
          const vehiclePlate = loc?.placa || ''
          return removeAccents(vehiclePlate.toLowerCase()).includes(searchText)
        })
      }),
    )
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      dateInitial: ['', [Validators.required]],
      dateEnd: ['', [Validators.required]],
      startHours: ['', [Validators.required]],
      endHours: ['', [Validators.required]],
      cliente: ['', [Validators.required]],
      subCliente: ['', [Validators.required]],
      status: [4, [Validators.required]],
      origem: this.origemControl,
      destino: this.destinoControl,
      typeService: ['', [Validators.required]],
      service: [''],
      typeVehicle: ['', [Validators.required]],
      typeDriver: ['', [Validators.required]],
      vehicle: [''],
      driver: [''],
      tgCode: [''],
      osCode: [''],
    })

    this.form.get('subCliente')?.disable()
  }

  listSubClients() {
    this.subClientService.listSubClient().subscribe({
      next: (res: any) => {
        this.subClientsList = res.data
      },
      error: (err: any) => {
        console.error(err.message)
      },
    })
  }

  onDriverSelected(event: any) {}

  createModel() {
    const formValue = this.form.value

    const dateInitialStr = formValue.dateInitial
      ? new Date(formValue.dateInitial).toLocaleDateString('pt-BR')
      : ''
    const dateFinalStr = formValue.dateEnd
      ? new Date(formValue.dateEnd).toLocaleDateString('pt-BR')
      : ''

    // Função para formatar a hora no formato hh:MM:ss
    const formatTime = (timeString: string) => {
      if (!timeString) return ''

      // Remove qualquer caractere não numérico
      const numericTime = timeString.replace(/\D/g, '')

      // Garante que temos pelo menos 4 dígitos (hhmm)
      const paddedTime = numericTime.padStart(4, '0')

      // Formata para hh:MM:ss
      return `${paddedTime.substr(0, 2)}:${paddedTime.substr(2, 2)}:00`
    }

    let origemValue = this.form.get('origem')?.value
    let destinoValue = this.form.get('destino')?.value

    if (origemValue == null) {
      origemValue = ''
    }

    if (destinoValue == null) {
      destinoValue = ''
    }

    return {
      dataInicio: dateInitialStr,
      dataFinal: dateFinalStr,
      nomeCliente: this.form.get('cliente')?.value,
      nomeSubCliente: this.form.get('subCliente')?.value,
      status:
        this.form.get('status')?.value === 0
          ? null
          : this.form.get('status')?.value,
      descricaoOrigem: origemValue,
      descricaoDestino: destinoValue,
      descricaoTipoServico: this.form.get('typeService')?.value,
      servico: this.form.get('service')?.value,
      descricaoTipoVeiculo: this.form.get('typeVehicle')?.value,
      descricaoTipoMotorista: this.form.get('typeDriver')?.value,
      codigoTg: this.form.get('tgCode')?.value,
      codigoOs: this.form.get('osCode')?.value,
    }
  }

  searchFleet() {
    if (this.panel) {
      this.panel.close()
    }
    const item = this.createModel()
    this.response.emit(item)
    // this.loading = true;
    // const item = this.createModel()
    // this.scheduleFleetService.searchPagedAgendaFrota(this.page, this.rows, item).subscribe({
    //   next: (res) => {
    //     this.response.emit(res.data)
    //     this.loadingList.emit(false)

    //     this.isExpanded = false
    //   },
    //   error: (err) => {
    //     this.response.emit(null)
    //   }
    // })
  }

  getListTypeDriver() {
    this.driverTypeService.listDriverType().subscribe({
      next: (res) => {
        this.listTypeDriver = res.data
      },
      error: (err) => {
        console.error('Ocorreu um erro ao listar os motoristas', err)
      },
    })
  }

  getListClient() {
    this.legalEntityClientService.listLegalEntityClient().subscribe({
      next: (res) => {
        this.listClient = res.data
      },
      error: (err) => {
        console.error('Ocorreu um erro ao listar os clientes', err)
      },
    })
  }

  getListLocations() {
    this.locationService.listLocation().subscribe({
      next: (res) => {
        this.listLocation = res.data
        // this.filteredOrigins = this.origemControl.valueChanges.pipe(
        //   startWith(''),
        //   map(value => this._filter(value))
        // )
        // this.filteredDestinations = this.destinoControl.valueChanges.pipe(
        //   startWith(''),
        //   map(value => this._filter(value))
        // )

        this.initOriginFilter()
      },
    })
  }

  getListTypeService() {
    this.serviceTypeService.listServiceType().subscribe({
      next: (res) => {
        this.listTypeService = res.data
      },
    })
  }

  getListTypeVehicle() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (res) => {
        this.listTypeVehicle = res.data
      },
    })
  }

  onOriginSelected(event: any) {}
  onDestinationSelected(event: any) {}

  editItem(item: any) {
    this.editIndex = this.itemsList.findIndex(
      (i) =>
        i.date === item.date &&
        i.startDate === item.startDate &&
        i.endDate === item.endDate,
    )
    this.editAgendaItem = { ...item }
    this.form.patchValue({
      date: item.date,
      startHours: item.startDate,
      endHours: item.endDate,
    })
  }

  deleteItem(item: any) {
    this.itemsList = this.itemsList.filter(
      (i) =>
        i.date !== item.date ||
        i.startDate !== item.startDate ||
        i.endDate !== item.endDate,
    )
  }

  saveEditAgendaItem() {
    if (this.editIndex !== null) {
      const formValue = this.form.value
      this.itemsList[this.editIndex] = {
        date: formValue.date
          ? new Date(formValue.date).toLocaleDateString('pt-BR')
          : '',
        startDate: formValue.startHours,
        endDate: formValue.endHours,
      }
      this.itemsList = [...this.itemsList]
      this.editIndex = null
      this.editAgendaItem = null

      this.form.patchValue({
        date: '',
        startHours: '',
        endHours: '',
      })
    }
  }

  reateForm(): void {
    if (this.panel) {
      this.panel.close()
    }

    this.createForm()

    // this.form = this.formBuilder.group({
    //   dateInitial: ['', [Validators.required]],
    //   dateEnd: ['', [Validators.required]],
    //   startHours: ['', [Validators.required]],
    //   endHours: ['', [Validators.required]],
    //   cliente: ['', [Validators.required]],
    //   status: ['', [Validators.required]],
    //   origem: ['', [Validators.required]],
    //   destino: [''],
    //   typeService: ['', [Validators.required]],
    //   service: [''],
    //   typeVehicle: ['', [Validators.required]],
    //   typeDriver: ['', [Validators.required]],
    //   osCode: [''],
    //   tgCode: [''],
    // })

    this.response.emit('reset')
  }

  resetForm() {
    this.form.reset()
  }

  cancel() {
    this.editIndex = null
    this.response.emit({ action: 'cancel' })
    this.resetForm()
  }
}
